<template>
    <el-dialog :title="title" :visible="dialogFormVisible" width="40%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form :inline="true" class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="应用类型">
                <el-select v-model="appModel.AppType" placeholder="请选择" @change="handleSelectChange" v-if="deviceType==='android'">
                    <el-option key="web" label="web" value="web">
                    </el-option>
                    <el-option key="android" label="android" value="android">
                    </el-option>
                </el-select>
                <el-select v-model="appModel.AppType" placeholder="请选择" @change="handleSelectChange" v-if="deviceType==='web'">
                    <el-option key="web" label="web" value="web">
                    </el-option>
                </el-select>
                <el-select v-model="appModel.AppType" placeholder="请选择" @change="handleSelectChange" v-if="deviceType==='dingding'">
                    <el-option key="dingding" label="dingding" value="dingding">
                    </el-option>
                </el-select>
                <el-select v-model="appModel.AppType" placeholder="请选择" @change="handleSelectChange" v-if="deviceType==='windows'">
                    <el-option key="windows" label="windows" value="windows">
                    </el-option>
                    <el-option key="web" label="web" value="web">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop="SearchKey">
                <el-input placeholder="请输入应用名称进行搜索" v-model="appModel.SearchKey" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </el-form-item>
        </el-form>
        <p style="text-align: left;margin-top: 0;color:#333;font-size: 16px;">请直接勾选需要添加的应用</p>
        <el-table :data="appList" style="width: 100%;margin-bottom: 20px;" row-key="KID" border :default-expand-all="true" :tree-props="{children: 'Childrens', hasChildren: 'hasChildren'}" @select="handleSelectionChange">
            <el-table-column type="selection" sortable width="40" :selectable="handleSelection">
            </el-table-column>
            <el-table-column prop="Name" label="应用名称" sortable width="180">
            </el-table-column>
            <el-table-column prop="AppVersion" label="版本号">
            </el-table-column>
            <el-table-column prop="AppType" label="应用类型">
            </el-table-column>
            <el-table-column prop="ReleaseNote" label="版本说明" sortable width="180">
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间">
            </el-table-column>
        </el-table>
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination background @current-change="handleCurrentChange" :current-page="appModel.Page" layout="total,prev, pager, next, jumper" :total="listCount" :page-size="appModel.Rows">
            </el-pagination>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { AddDeviceApp } from '../../../api/device'
    import { GetAppVersionInfo } from '../../../api/app'
    export default {
        data() {
            return {
                title: '添加设备应用',
                name: 'add',
                appList: [],
                list: [],
                listCount: null,
                model: {
                    DeviceID: null,
                    AppIds: [],
                },
                appModel: {
                    Page: 1,
                    Rows: 20,
                    SearchKey: '',
                    DeviceID: null,
                    AppType: ''
                },
                rules: {
                    AppVersion: [{ required: true, message: '请输入应用版本号', trigger: 'blur' }],
                    AppUrl: [{ required: true, message: '请输入版本跳转路径', trigger: 'blur' }],
                    AppUpdateLog: [{ required: true, message: '请输入版本更新日志', trigger: 'blur' }],
                },
                activeNames: [],
                selectList: []
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            deviceOID: {
                required: true
            },
            deviceType: {
                required: true
            }
        },
        watch: {
            'appModel.SearchKey': {
                handler(newVal, oldVal) {
                    if (newVal === '') {
                        this.appModel.SearchKey = '';
                        this.GetAppVersionInfo();
                    }
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            selectChange(val) {
                this.model.AppIds = val;
                
            },
            GetAppVersionInfo() {
                GetAppVersionInfo(this.appModel).then(data => {
                    if (!data.iserror) {
                        this.appList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            init() {
                this.appModel.DeviceID = this.model.DeviceID = this.deviceOID;
                this.appModel.AppType = this.deviceType;
                this.GetAppVersionInfo();
            },
            handleCurrentChange(val) {
                this.appModel.Page = val;
                this.GetAppVersionInfo();
            },
            handleSave() {
                let arr = [];
                if (!this.selectList.length) {
                    this.$message({
                        message: '请先勾选应用',
                        type: 'error'
                    });
                } else {
                    this.selectList.forEach(item => {
                        arr.push(item.OID)
                    })
                    this.model.AppIds = arr;
                    this.AddDeviceApp();
                    // console.log(arr)
                }
            },
            handleClose() {
                this.$emit('closeAddDialog')
            },
            AddDeviceApp() {
                AddDeviceApp(this.model).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.GetAppVersionInfo();
                    }
                })
            },
            handleSearch() {
                this.GetAppVersionInfo();
            },
            handleSelectChange() {
                this.appModel.Page = 1;
                this.GetAppVersionInfo();
            },
            handleSelectionChange(selection, row) {
                this.selectList = selection;
                console.log(!row._checked)
                if (!row._checked) {
                    this.$set(row, '_checked', true)
                    this.appList.filter(x => x.PID == row.PID)[0].Childrens.filter(x => x.OID != row.OID).forEach(x => { this.$set(x, '_disabled', true) })
                } else {
                    this.$set(row, '_checked', false)
                    this.appList.filter(x => x.PID == row.PID)[0].Childrens.filter(x => x.OID != row.OID).forEach(x => { this.$set(x, '_disabled', false) })
                }
            },
            handleSelection(row, index) {
                if (row.Childrens) {
                    return false;
                } else {
                    return !row._disabled
                }
            }
        }
    }
</script>

<style>

</style>